import { render } from "./xAppsXCargoDockPage.vue?vue&type=template&id=d49b242a&scoped=true"
import script from "./xAppsXCargoDockPage.vue?vue&type=script&lang=js"
export * from "./xAppsXCargoDockPage.vue?vue&type=script&lang=js"

import "./xAppsXCargoDockPage.vue?vue&type=style&index=0&id=d49b242a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d49b242a"]])

export default __exports__